// Every failure the player can hit has a plain message and an exact detail (plan.md §5.6).
export type ErrorKind = 'link' | 'network' | 'not-found' | 'rate-limit' | 'manifest' | 'hash' | 'too-big' | 'rom' | 'crash' | 'unsupported' | 'size' | 'module';

export class RtwError extends Error {
  readonly kind: ErrorKind;
  readonly detail: string;
  constructor(kind: ErrorKind, message: string, detail = '') {
    super(message);
    this.kind = kind;
    this.detail = detail;
  }
}

export function asRtwError(e: unknown): RtwError {
  if (e instanceof RtwError) return e;
  const msg = e instanceof Error ? `${e.name}: ${e.message}` : String(e);
  return new RtwError('crash', 'Something went wrong.', msg);
}
